import { useLazyQuery as h } from "@apollo/client";
import v from "../graphql/getAccountInvitees.js";
import { DEFAULT_PAGE_INFO as z } from "../../common-lib/constants/paging.js";
import { publicAccountSchema as A } from "../../temp-lib/deserialize/yup/account.js";
import { deserializeResponse as S, deserializePageInfo as b } from "../../temp-lib/graphql/deserialize/index.js";
import * as c from "ramda";
import { useState as i, useCallback as P } from "react";
const G = () => {
  const [e, { loading: p }] = h(v), [m, u] = i([]), [f, g] = i(z), l = P(
    async (d) => {
      const { isInvitee: I, pageSize: t, page: a } = d, o = await e({
        variables: {
          input: {
            isInvitee: I,
            pageSize: t,
            skip: (a - 1) * t
          }
        }
      }), y = S(o), s = c.map((r) => A.validateSync(r, {
        context: { data: r }
      }), c.pathOr([], ["edges"], y));
      u(s);
      const n = b(o, { page: a, pageSize: t });
      return g(n), {
        data: s,
        pageInfo: n
      };
    },
    [e]
  );
  return {
    data: m,
    loading: p,
    pageInfo: f,
    fetch: l
  };
};
export {
  G as default
};
//# sourceMappingURL=useGetAccountInvitees.js.map
